import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class AdminMemberService {
  constructor() {
    this.endpoints = createPrefix('/admin/members', {
      member: '',
      lookup: [
        '/lookup',
        {
          byEmail: '/by-email/',
        },
      ],
      beneficiaries: [
        '/beneficiaries',
        {
          byEmail: '/by-email/',
        },
      ],
    })
  }

  static create() {
    return new AdminMemberService()
  }

  async queryMembers(params) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.get(servicePath, { params })
    return data
  }

  async getMemberByEmail(email) {
    const servicePath = this.endpoints.lookup.byEmail()
    const { data } = await axios.get(servicePath + email)
    return data
  }

  async getMemberById(id) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.get(`${servicePath}/${id}`)
    return data
  }

  async updateMember(member) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.put(`${servicePath}/${member.id}`, member)
    return data
  }

  async getBeneficiaryById(params) {
    const servicePath = this.endpoints.beneficiaries.byEmail()
    const { data } = await axios.get(servicePath + params)
    return data
  }

  async getMemberBankAccount(memberId) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.get(`${servicePath}/${memberId}/bank-accounts`)
    return { content: data }
  }

  async addMemberBankAccount(memberId, bankAccount) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.post(`${servicePath}/${memberId}/bank-accounts`, bankAccount)
    return data
  }

  async removeMemberBankAccount(memberId, iban) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.delete(`${servicePath}/${memberId}/bank-accounts/${iban}`)
    return data
  }

  async getMemberBalance(memberId) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.get(`${servicePath}/${memberId}/balance`)
    return data
  }

  async getMemberBalanceHistory(memberId) {
    const servicePath = this.endpoints.member()
    const { data } = await axios.get(`${servicePath}/${memberId}/balance/history`)
    return data
  }
}
